import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import md5 from "md5";
import moment from "moment";
import React, { useState } from "react";

import { toast } from "react-toastify";
import { GRAY_LIGHT, VARIANT, WHITE } from "../../../constants/colors";
import Login from "../../../services/loginApi";
import CheckPasswordProgressBar from "./checkPasswordProgressBar";
import { useNavigate } from "react-router-dom";

const ModalChangePassword = ({ isOpen, setIsOpen, user }: any) => {
  const finalRef = React.useRef(null);

  const onClose = () => {};

  const navigate = useNavigate();

  const [pwd, setPwd] = useState({
    new: "",
    confirm: "",
  });

  async function ChangePassword() {
    if (pwd.new === pwd.confirm) {
      const objeto = {
        pwd: pwd.new,
        email: user.email,
        secret: md5(
          `${user.email}-${moment().format("DD/MM/YYYY")}-supervisor`
        ),
      };
      try {
        const response = await Login.changePassword(objeto);
        toast.success("Senha alterada com sucesso!");
        setIsOpen(false);
      
      } catch (error) {
        toast.error("Não foi possível alterar a senha!");
      }
    } else {
      toast.error("As senhas não são iguais!");
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex justifyContent={"center"} w={"100%"} mt={2}>
              <Text fontWeight={"bold"} fontSize={"2xl"}>
                Alteraração de senha obrigatória
              </Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            <Box
              h={"70px"}
              justifyContent={"center"}
              textAlign={"center"}
              alignContent={"center"}
            >
              <Text fontSize="2xl">E-mail</Text>
              <Text fontSize={"20px"}>{user && user.email}</Text>
            </Box>
            <Flex flexDir={"column"}>
              <FormControl my={2}>
                <FormLabel>Nova Senha</FormLabel>
                <Input
                  placeholder="Digite a senha"
                  type={"password"}
                  onChange={(e: any) => {
                    setPwd({ ...pwd, new: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl my={2}>
                <FormLabel>Repita a Nova Senha</FormLabel>
                <Input
                  placeholder="Repita a senha"
                  type={"password"}
                  onChange={(e: any) => {
                    setPwd({ ...pwd, confirm: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Força da senha</FormLabel>
                <CheckPasswordProgressBar pwd={pwd} />
              </FormControl>
            </Flex>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              isDisabled={pwd.new === "" || pwd.confirm === "" ? true : false}
              background={VARIANT}
              color={WHITE}
              onClick={() => {
                ChangePassword();
              }}
            >
              Alterar Senha
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalChangePassword;
